document.addEventListener('DOMContentLoaded', function() {
  MicroModal.init({
    openTrigger: 'data-popup-store-password',
    disableScroll: true,
    onShow: function(modal, el, event) {
      event.preventDefault();
    },
    onClose: function(modal, el, event) {
      event.preventDefault();
    }
  });
});